import { photoUrl } from "./urls";

const feast = {
    id: 121,
    date: 'November 2020',
    image: `${photoUrl}/feast.png`,
    title: 'Thanksgiving Feast',
    url: `${photoUrl}/feast.png`
};
const hats = {
    id: 122,
    date: 'June 2020',
    image: `${photoUrl}/hats.png`,
    title: 'Funny Hats',
    url: `${photoUrl}/hats.png`
};
const kickball = {
    id: 123,
    date: 'April 2019',
    image: `${photoUrl}/KickballTeam.jpg`,
    title: 'iKickballz',
    url: `${photoUrl}/KickballTeam.jpg`
};
const lego = {
    id: 221,
    date: 'January 2021',
    image: `${photoUrl}/lego-office.png`,
    title: 'Lego Office',
    url: `${photoUrl}/lego-office.png`
};
const spiderverse = {
    id: 124,
    date: 'February 2019',
    image: `${photoUrl}/spiderverse.png`,
    title: 'Into the Spiderverse',
    url: `${photoUrl}/spiderverse.png`
};
const cobra = {
    id: 222,
    date: 'May 2021',
    image: `${photoUrl}/cobra.png`,
    title: 'Cobra Stand Up',
    url: `${photoUrl}/cobra.png`
};
const tent = {
    id: 320,
    date: 'May 2022',
    image: `${photoUrl}/tent.png`,
    title: 'Tent Stand-Up',
    url: `${photoUrl}/tent.png`
};
const sunny = {
    id: 223,
    date: 'February 2021',
    image: `${photoUrl}/sunny.png`,
    title: 'Mac and Charlie',
    url: `${photoUrl}/sunny.png`
};
const inOffice = {
    id: 321,
    date: 'April 2022',
    image: `${photoUrl}/in-office.png`,
    title: 'iReconnectz Office Day',
    url: `${photoUrl}/in-office.png`
};
const poof = {
    id: 224,
    date: 'August 2021',
    image: `${photoUrl}/poof.gif`,
    title: 'Poof!',
    url: `${photoUrl}/poof.gif`,
};
const breakfast = {
    id: 322,
    date: 'January 2022',
    image: `${photoUrl}/stand-up-cereal.gif`,
    title: 'Daily Stand Up',
    url: `${photoUrl}/stand-up-cereal.gif`,
}
const homeElf = {
    id: 225,
    date: 'December 2021',
    image: `${photoUrl}/elf-home.jpg`,
    title: 'Elf at Home',
    url: `${photoUrl}/elf-home.jpg`,
};
const presentElf = {
    id: 226,
    date: 'December 2021',
    image: `${photoUrl}/present-elf.jpg`,
    title: 'Elf as a Present',
    url: `${photoUrl}/present-elf.jpg`,
};
const toiletElf = {
    id: 227,
    date: 'December 2021',
    image: `${photoUrl}/toilet-elf.jpg`,
    title: 'Elf at an Outhouse',
    url: `${photoUrl}/toilet-elf.jpg`,
};
const vaccineElfA = {
    id: 228,
    date: 'December 2021',
    image: `${photoUrl}/vaccine-elf-jpg.jpg`,
    title: 'Elf Getting Vaccinated',
    url: `${photoUrl}/vaccine-elf-jpg.jpg`,
};
const vaccineElfB = {
    id: 229,
    date: 'December 2021',
    image: `${photoUrl}/vaccine-elf-2.jpg`,
    title: 'Elf Getting Vaccinated Part 2',
    url: `${photoUrl}/vaccine-elf-2.jpg`,
};
const workoutElf = {
    id: 230,
    date: 'December 2021',
    image: `${photoUrl}/workout-elf.jpg`,
    title: 'Elf Getting Fit',
    url: `${photoUrl}/workout-elf.jpg`,
};

export const photos = [spiderverse, lego, kickball, hats, feast,
    cobra, sunny, inOffice, poof, tent, homeElf, presentElf, toiletElf,
    vaccineElfA, vaccineElfB, workoutElf, breakfast];